import { PermissionsBaseModel } from '@fluxonos/features/user/models/permissions-base.model';
import { CustomerPermissionsEnum } from '@fluxonos/fluxonos-dto';

export class PermissionsCustomerModel extends PermissionsBaseModel {
  public get canView(): boolean {
    const permissions = [CustomerPermissionsEnum.VIEW__FLUXONOS__CUSTOMER];
    return this.checkPermissions(permissions);
  }

  public get canChange(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerPermissionsEnum.CHANGE__FLUXONOS__CUSTOMER];
    return this.checkPermissions(permissions);
  }

  public get canAdd(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerPermissionsEnum.ADD__FLUXONOS__CUSTOMER];
    return this.checkPermissions(permissions);
  }

  public get canDelete(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [CustomerPermissionsEnum.DELETE__FLUXONOS__CUSTOMER];
    return this.checkPermissions(permissions);
  }

  public get isAdmin(): boolean {
    return this.canView && this.canChange && this.canAdd && this.canDelete;
  }
}
